module.exports = __webpack_public_path__ + "assets/img/thumb-Super-Obvious-Landing-Page.1a9cc7ce.jpg";